import React from 'react';
import { createPortal } from 'react-dom';
import { XIcon, CheckCircleIcon } from 'lucide-react';
interface SuccessModalProps {
  onClose: () => void;
  title?: string;
  message?: string;
}
export function SuccessModal({
  onClose,
  title = 'Payment Processed',
  message = "The customer's card has been successfully charged."
}: SuccessModalProps) {
  return createPortal(<div className="fixed inset-0 z-[9999] flex items-center justify-center p-4" style={{
    margin: 0,
    background: 'rgba(17,24,39,0.5)'
  }} data-id="element-4555">
      <div className="bg-white rounded-xl shadow-xl w-full max-w-md overflow-hidden" data-id="element-4556">
        <div className="px-6 py-4 border-b border-gray-200 flex justify-between items-center" data-id="element-4557">
          <h3 className="text-base font-semibold text-gray-900" data-id="element-4558">{title}</h3>
          <button onClick={onClose} className="text-gray-400 hover:text-gray-600 transition-colors" data-id="element-4559">
            <XIcon size={18} data-id="element-4560" />
          </button>
        </div>
        <div className="p-6 flex flex-col items-center" data-id="element-4561">
          <div className="w-14 h-14 rounded-full bg-green-50 flex items-center justify-center mb-4" data-id="element-4562">
            <CheckCircleIcon size={28} className="text-green-600" data-id="element-4563" />
          </div>
          <p className="text-center text-sm text-gray-600 mb-5" data-id="element-4564">{message}</p>
          <button onClick={onClose} className="px-5 py-2 bg-[#F7941D] hover:bg-[#D97B06] text-white text-sm font-medium rounded-lg transition-colors shadow-sm" data-id="element-4565">
            Done
          </button>
        </div>
      </div>
    </div>, document.body);
}